module.exports = __webpack_public_path__ + "static/bored-c3e266008ecce27ca24220472abdcd0a.webm";